import Vue from 'vue'
import Vuex from 'vuex'
import chat from '../store/chat'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ShowRoom: false,
    isLoading: true,
  },

  actions: {
    ShowChatRoom(context, status) {
      context.commit('SHOWCHATROOM', status)
    },
    updateLoading(context, status) {
      context.commit('LOADING', status)
    },
  },
  mutations: {
    SHOWCHATROOM(state, status) {
      state.ShowRoom = status
    },

    LOADING(state, status) {
      state.isLoading = status
    },
  },

  modules: {
    chat,
  },

  getters: {
    ShowRoom: (state) => state.ShowRoom,
    isLoading: (state) => state.isLoading,
  },
})
